import styled from 'styled-components';
const ViewEvents = styled.div`
  color:DeepSkyBlue; 
  font-weight:bold; 
  font-size:13px;
`;

const Summary = styled.div`
background-color:white;
font-family:Calibri;
padding:30px 10px 30px 10px
`;

const Heading = styled.div`
display:flex;
flex-direction:row;
align-items:center;
`;

const InfoHeading = styled.div`
color:gray; 
font-size:10px;
`;

const HeadingWithFilter = styled.div`
padding:10px; 
display:flex;
flex-direction:row; 
justify-content:space-between; 
align-items:center;
`;

const EventHeading = styled.div`
color:gray;
font-size:10px;
`;

const SecondHeading = styled.div`
margin:10px;
display:flex;
flex-direction:row; 
justify-content:space-between;
align-items: center;
`;

const EventRule = styled.div`
display:flex;
flex-direction:column;
`;

const SingleEvent = styled.div`
margin:10px;
display:flex;
flex-direction:row;
justify-content:space-between;
align-items:center;
`;

const GeneralInfo = styled.div`
font-weight: bold;
font-size:20px;
margin:10px 0px 10px 0px;
`;

const Bold = styled.div`
font-weight:bold;
font-size:20px
`;

const Line = styled.hr`
margin: 10px;
`;

const Container = styled.div`
width:40%
`;

const SideMargin = styled.div`
margin: 10px;
`;

const HeadingWithDate = styled.div`
display:flex;
flex-direction: column;
padding-left:10px;
`;

const Date = styled.div`
color:gray;
font-size:15px;
`;

const BottomMargin = styled.div`
margin-bottom:20px;
`;
export  {
    Heading,
    Summary,
    EventHeading,
    InfoHeading,
    HeadingWithFilter,
    ViewEvents,
    SecondHeading,
    EventRule,
    SingleEvent,
    GeneralInfo,
    Bold,
    Line,
    Container,
    SideMargin,
    HeadingWithDate,
    Date,
    BottomMargin
}